import { Common } from './Common';
import { Employee } from './Employees';

export class Invite extends Common {
    emp_id: string;
    name: string;
    complete_address: string;
    mobile: string;
    status: string;
    type: string;
    message: string; // by employee
    via: string;
    logo: string;
    remarks: string; // by approver
    business_id: string;
    pincode: string;

    approved_by: string;

    // employee: Employee;

    community: string;
    sub_community: string;

    email: string; // Used as message
    country: string;
    state: string;
    district: string;
    area: string;
    town: string;

    m_name: string;
    m_address: string;
}
